<template>
  <div class="LuxinWidget lxn-float-left lxn-border-round lxn-overflow-hidden" :class="widgetSize">
    <div v-if="!folderWidget" class="LuxinWidget-header lxn-w100" :style="headerColor">
      <div v-if="!editing" class="LuxinWidget-header-circle lxn-circle" :class="[$store.getters.language.floatClass]" :style="headerCircleColor">
      </div>
      <div v-else class="LuxinWidget-header-moveIcon widgetMoveHandle" :class="[$store.getters.language.floatClass]">
        <ButtonIcon :size="18" bgColor="hubColor" icon="move" iconColor="#FFFFFF" :padding="1" />
      </div>
      <div class="LuxinWidget-header-text lxn-text lxn-overflow-hidden" :class="[editTextClass, $store.getters.language.floatClass, $store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
        {{widgetName}}
      </div>
    </div>
    <div class="LuxinWidget-body lxn-w100 lxn-pos-rel" :class="folderWidget ? 'folderWidget' : ''">
      <div class="LuxinWidget-wrapper-body lxn-w100 lxn-h100" :class="editingClass">
        <slot>
        </slot>
      </div>
      <div v-if="editing && folderWidget" class="LuxinWidget-header-moveIcon2 lxn-pos-abs widgetMoveHandle" :class="[$store.getters.language.floatClass]">
        <ButtonIcon :size="18" bgColor="hubColor" icon="move" iconColor="#FFFFFF" :padding="1" />
      </div>
      <div v-if="editing" class="LuxinWidget-wrapper-deleteIcon lxn-pos-abs">
        <ButtonIcon @click="deleteWidget(index)" :size="35" bgColor="#F36C4F" icon="trash" iconColor="#FFFFFF" :padding="5" />
      </div>
      <div v-if="editing" class="LuxinWidget-wrapper-settingsIcon lxn-pos-abs">
        <ButtonIcon @click="$router.push('/edit' + widget.type + '/' + index)" :size="35" bgColor="#1EA5DE" icon="cog" iconColor="#FFFFFF" :padding="5" />
      </div>
    </div>
    <!-- <div v-else class="LuxinWidget-body lxn-w100 lxn-pos-rel">
      <div class="LuxinWidget-wrapper-editTexts lxn-w100 lxn-title lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
        {{widgetType}}
      </div>
      <div class="LuxinWidget-wrapper-deleteIcon lxn-pos-abs">
        <ButtonIcon @click="deleteWidget(index)" :size="35" bgColor="#F36C4F" icon="trash" iconColor="#FFFFFF" :padding="5" />
      </div>
      <div class="LuxinWidget-wrapper-settingsIcon lxn-pos-abs">
        <ButtonIcon @click="$router.push('/edit' + widget.type + '/' + index)" :size="35" bgColor="#1EA5DE" icon="cog" iconColor="#FFFFFF" :padding="5" />
      </div>
    </div> -->
  </div>
</template>

<script>
import ButtonIcon from '@/components/ButtonIcon.vue';

export default {
  name: 'LuxinWidget',
  props: {
    index: Number,
    editing: Boolean
  },
  components: {
    ButtonIcon
  },
  data: function () {
    return {
    }
  },
  computed: {
    widget: function () {
      return this.$store.state.widgets[this.index];
    },
    folderWidget: function () {
      return this.widget.type == 'folderWidget';
    },
    widgetSize: function () {
      if(this.widget.size == 2){
        return 'fullWidth';
      }else{
        if(this.widget.type == 'singleSwitchWidget' ){
          return 'halfHeight';
        }else if(this.widget.type == 'singleThreewaySwitchWidget'){
          return 'halfHeight';
        }else if(this.widget.type == 'S1TouchWidget'){
          return 'halfHeight';
        }else if(this.widget.type == 'doubleSwitchWidget'){
          return 'halfHeight';
        }else if(this.widget.type == 'sceneButtonWidget'){
          return 'halfHeight';
        }else if(this.widget.type == 'rgbwWidget'){
          return 'halfHeight';
        }else if(this.widget.type == 'smartCurtainWidget'){
          return 'halfHeight';
        }else if(this.widget.type == 'temperatureWidget'){
          return 'halfHeight';
        }else if(this.widget.type == 'humidityWidget'){
          return 'halfHeight';
        }else if(this.widget.type == 'folderWidget'){
          return 'halfHeightFullWidth';
        }else if(this.widget.type == 'autoThreewaySwitchWidget'){
          return 'fullHeight';
        }else{
          return this.widget.type;
        }
      }
    },
    widgetType: function () {
      //TODO: add widgets here
      if(this.widget.type == 'singleSwitchWidget'){
        return this.$store.getters.language.texts.LuxinWidget_singleSwitch
      }else if(this.widget.type == 'S1TouchWidget'){
        return this.$store.getters.language.texts.LuxinWidget_singleSwitch  
      }else if(this.widget.type == 'singleThreewaySwitchWidget'){
        return this.$store.getters.language.texts.LuxinWidget_singleThreeWaySwitch
      }else if(this.widget.type == 'sceneButtonWidget'){
        return this.$store.getters.language.texts.LuxinWidget_sceneButton
      }else if(this.widget.type == 'temperatureAutomationWidget'){
        return this.$store.getters.language.texts.LuxinWidget_temperatureAutomation
      }else if(this.widget.type == 'rgbwWidget'){
        return this.$store.getters.language.texts.LuxinWidget_RGBW
      }else if(this.widget.type == 'smartCurtainWidget'){
        return this.$store.getters.language.texts.LuxinWidget_SmartCurtain
      }else if(this.widget.type == 'doubleSwitchWidget'){
        return this.$store.getters.language.texts.LuxinWidget_doubleSwitch
      }else if(this.widget.type == 'acRemoteWidget'){
        return this.$store.getters.language.texts.LuxinWidget_acRemote
      }else if(this.widget.type == 'tvRemoteWidget'){
        return this.$store.getters.language.texts.LuxinWidget_tvRemote
      }else if(this.widget.type == 'temperatureWidget'){
        return this.$store.getters.language.texts.LuxinWidget_temperatureWidget
      }else if(this.widget.type == 'humidityWidget'){
        return this.$store.getters.language.texts.LuxinWidget_humidityWidget
      }else if(this.widget.type == 'folderWidget'){
        return this.$store.getters.language.texts.LuxinWidget_folder
      }else if(this.widget.type == 'autoThreewaySwitchWidget'){
        return this.$store.getters.language.texts.LuxinWidget_autoThreeWaySwitch
      }else{
        return 'Widget';
      }
    },
    editingClass: function () {
      if(this.editing){
        return "editMode"
      }else{
        return ""
      }
    },
    headerColor: function () {
      return "background-color: " + this.$store.state.themeSecondaryColors[this.widget.color] + ";"
    },
    hub: function () {
      return this.$store.getters.getHubByUUID(this.widget.hubUUID);
    },
    widgetName: function () {
      return this.widget.name;
    },
    hubColor: function () {
      var hubColor = this.$store.state.themeMainColors[this.hub.color];
      if(hubColor == undefined){
        return this.$store.state.themeMainColors[this.widget.color];
      }else{
        return this.$store.state.themeMainColors[this.hub.color];
      }
    },
    headerCircleColor: function () {
      return "border-color: " + this.hubColor + ";"
    },
    editTextClass: function () {
      if(this.editing){
        return 'editing'
      }else{
        return '';
      }
    },
  },
  methods: {
    deleteWidget: function (index) {
      if(this.widget.type == 'temperatureAutomationWidget'){
        this.$router.push('/deleteTemperatureAutomation/' + index);
      }else if(this.widget.type == 'folderWidget'){
        this.$router.push('/deleteFolderWidget/' + index);
      }else{
        this.$router.push('/deleteWidget/' + index);
      }
    },
  }
}
</script>

<style>
  .LuxinWidget {
    width: calc(50% - 10px);
    height: 210px;
    margin-bottom: 10px;
    margin-left: 5px;
    margin-right: 5px;
  }
  .LuxinWidget.fullWidth {
    width: calc(100% - 10px);
  }
  .LuxinWidget.halfHeight {
    width: calc(50% - 10px);
    height: 100px;
  }
  .LuxinWidget.halfHeightFullWidth {
    width: calc(100% - 10px);
    height: 120px;
  }
  .LuxinWidget-header {
    height: 30px;
  }
  .LuxinWidget-body {
    height: calc(100% - 30px);
    background-color: #ECECEC;
  }
  .LuxinWidget-body.folderWidget {
    height: 100%;
  }
  .LuxinWidget-wrapper-body.editMode {
    filter: blur(2px);
    -webkit-filter: blur(2px);
    opacity: 0.6;
  }
  .LuxinWidget-header-circle {
    width: 10px;
    height: 10px;
    margin: 5px;
    margin-top: 10px;
    background-color: #FFFFFF;
    box-sizing: border-box;
    border-style: solid;
    border-width: 1px;
  }
  .LuxinWidget-header-moveIcon {
    width: 20px;
    height: 20px;
    padding-top: 5px;
    margin-right: 3px;
    margin-left: 3px;
  }
  .LuxinWidget-header-moveIcon2 {
    width: 20px;
    height: 20px;
    top: 10px;
    right: 10px;
  }
  .LuxinWidget-header-text {
    width: calc(100% - 40px);
    height: 30px;
    line-height: 30px;
    color: #ffffff;
  }
  .LuxinWidget-header-text.editing {
    width: calc(100% - 26px);
  }
  .LuxinWidget-wrapper-editTexts {
    height: 40px;
    line-height: 40px;
  }
  .LuxinWidget-wrapper-deleteIcon {
    width: 35px;
    height: 35px;
    left: 5px;
    bottom: 5px;
  }
  .LuxinWidget-wrapper-settingsIcon {
    width: 35px;
    height: 35px;
    right: 5px;
    bottom: 5px;
  }
  .LuxinWidget.fullHeight{
    height: 310px;
  }
</style>
